import { Action } from "./actionsShared";

export const FETCH_MODEL_CLASSES_PREFIX = "FETCH_MODEL_CLASSES";

//Model
export const fetchModelClasses = (algId) => {
  const url = `/api/models/${algId}/classes`;
  return Action.GET(FETCH_MODEL_CLASSES_PREFIX, url, true);
};
